import QueryStringUtil from 'utils/QueryStringUtil';
   
export default class VistaprintImageUtil {
    static getUploadPreviewURL(uploadId, options={}) {
        const {
            maxHeight = 300,
            maxWidth = 300,
        } = options;
    
        return `/vp/ns/imagepreview.aspx?admin=1&trim=1&maxwidth=${maxWidth}&maxheight=${maxHeight}&image_type=upload&image_id=${uploadId}`;
    }
    
    /**
     * Constructs a URL for a preview of the given page for the document with the given Vistaprint Alt Document Id
     * @param {String} altDocId - the Vistaprint Alt Document Id
     * @param {Number} pageNumber - the page of the document
     * @param {Object} options - specify height or width for the preview
     */
    static getDocumentPreviewURL(altDocId, pageNumber, options = {}) {
      const {
        height,
        width,
      } = options;
    
      const query = {
        noChrome: 1, // remove black outline
        png: 1,
        page: pageNumber,
        alt_doc_id: altDocId,
        height,
        width,
      };
    
      return `/lp.aspx${QueryStringUtil.objectToQuery(query)}`;
    }
    
    /**
     * Constructs a URL for a preview for the Template with the given Vistaprint Combo Id
     * @param {String} comboId - the Vistaprint Combo Id
     * @param {Object} options - specify height or width for the preview
     */
    static getTemplatePreviewURLByComboId(comboId, options = {}) {
      const {
        height,
        width,
      } = options;
    
      const query = {
        noChrome: 1, // remove black outline
        png: 1,
        combo_id: comboId,
        height,
        width,
      };
    
      return `/lp.aspx${QueryStringUtil.objectToQuery(query)}`;
    }
    
    /**
     * Constructs a URL for a preview for the Template with the given Vistaprint Template Descriptor
     * @param {String} templateDescriptor - the Vistaprint templateDescriptor
     * @param {Object} options - specify height or width for the preview
     */
    static getTemplatePreviewURLByTemplateDescriptor(templateDescriptor, options = {}) {
      const {
        height,
        width,
      } = options;
    
      const query = {
        noChrome: 1, // remove black outline
        png: 1,
        template: encodeURIComponent(templateDescriptor),
        height,
        width,
      };
    
      return `/lp.aspx${QueryStringUtil.objectToQuery(query)}`;
    }
    
    /**
     * Constructs a URL for a preview for the Image with the given ImageId
     * @param {String} imageId - the Vistaprint Image Id
     * @param {Object} options - specify height or width for the preview
     */
    static getImagePreviewURL(imageId, options = {}) {
      const {
        height,
        width,
      } = options;
    
      const query = {
        trim: true,
        format: 'trypng',
        image_id: imageId,
        maxheight: height,
        maxwidth: width,
      };
    
      return `/preview/image.caspx${QueryStringUtil.objectToQuery(query)}`;
    }
}



// WEBPACK FOOTER //
// ./src/utils/VistaprintImageUtil.js